import Track from "./Track";

export function handleSliders() {
    let $track = $(".js-track-wrap");

    if ($track.length > 0) {
        $track.each((i, el) => {
            let $el = $(el);
            let maxWidth = 'undefined' === typeof $el.attr('data-max-width') ? false : parseInt($el.attr('data-max-width'));
            let minWidth = 'undefined' === typeof $el.attr('data-min-width') ? false : parseInt($el.attr('data-min-width'));

            let track = new Track($el, {
                classes: {
                    block: "slider",
                },
            });

            if (minWidth || maxWidth) {
                $(window).on('resize', () => {
                    handleTrackOnResize(track, minWidth, maxWidth);
                });

                handleTrackOnResize(track, minWidth, maxWidth);
            }
        });
    }
}

function handleTrackOnResize(track, minWidth, maxWidth) {
    let enabled = true;

    if (minWidth && window.outerWidth <= minWidth) {
        enabled = false;
    }

    if (maxWidth && window.outerWidth >= maxWidth) {
        enabled = false;
    }

    if (enabled) {
        track.enable();
    } else {
        track.disable();
    }
}
